export default __webpack_public_path__ + "static/ai-hero-b6235c92ed3b7c40066fd46d398134f9.mp4";